import { useHref } from './useHref';
import { useCallback } from 'react';
import { getWindow } from '../utils/browser';
export const useReloadLinkProps = ({
  to,
  href: hrefProp,
  replace,
  external,
  onClick
}) => {
  let href = useHref(to);
  href = hrefProp !== null && hrefProp !== void 0 ? hrefProp : href;
  const handleClick = useCallback(e => {
    onClick === null || onClick === void 0 || onClick(e);

    // Caller's onClick prevented default — they own navigation, don't clobber.
    if (e.defaultPrevented) {
      return;
    }
    if (replace && !(external || e.metaKey)) {
      e.preventDefault();
      getWindow().location.replace(href);
    }
  }, [onClick, replace, href, external]);
  return {
    href,
    handleClick
  };
};